import React from 'react'
import './loader.css'
import { Grid } from 'react-loader-spinner'
const LoaderSpinner = () => {
  return (
    <div className="container-page">
      <div className="container-loader">
        <Grid height="250" width="250" color="#31C129" ariaLabel="loading" />
        <h1 className="message"> {`Biomédica Electrónica SAC Bioelectrón SAC`}</h1>
      </div>
    </div>
  )
}

export default LoaderSpinner
